import React, { useRef } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import {
  ChevronLeft as ChevronLeftIcon,
  Print as PrintIcon,
} from '@material-ui/icons';
import ReactToPrint from 'react-to-print';
import { useHistory } from 'react-router-dom';
import CertificateBorder from 'components/certificateBorder';
import Header from './components/Header';
import Side from './components/Side';
import Summary from './components/Summary';
import Animals from './components/Animals';
import Footer from './components/Footer';

const useStyles = makeStyles(() => ({
  page: {
    padding: '20px 20px 40px',
    overflow: 'auto',
  },
  actions: {
    marginBottom: '2em',
    '& button': {
      marginRight: '1em',
      '& svg': {
        marginRight: '5px',
        fontSize: '16px',
      },
    },
  },
  previewWrapper: {
    width: '990px',
    margin: 'auto',
  },
  wrapper: {
    fontSize: '16px',
    padding: '20px 0',
    fontWeight: '400',
    fontFamily: 'Roboto, sans-serif',
  },
  mainRow: {
    display: 'flex',
    marginBottom: '2em',
    '& > div:first-child': {
      width: 'calc(100% - 180px)',
      paddingRight: '1.5em',
    },
    '& > div:last-child': {
      width: '180px',
    },
  },
}));

const Certificate = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.mainRow}>
        <div>
          <Header />
          <Summary />
        </div>
        <div>
          <Side />
        </div>
      </div>
      <Animals />
      <Footer />
    </div>
  );
};

const ProfileCertificate = () => {
  const classes = useStyles();
  const history = useHistory();
  const certRef = useRef();

  const handleBack = () => {
    history.push('/profile/certificates');
  };

  return (
    <div className={classes.page}>
      <div className={classes.actions}>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={handleBack}
          data-id="Y9hlw"
        >
          <ChevronLeftIcon />Go back
        </Button>
        <ReactToPrint
          trigger={() => (
            <Button
              size="small"
              variant="contained"
              color="primary"
              data-id="yhUZp"
            >
              <PrintIcon />Print Certificate
            </Button>
          )}
          content={() => certRef.current}
        />
      </div>
      <div className={classes.previewWrapper}>
        <Certificate />
      </div>
      <div style={{ display: 'none' }}>
        <div ref={certRef} style={{ width: '1000px' }}>
          <CertificateBorder>
            <Certificate />
          </CertificateBorder>
        </div>
      </div>
    </div>
  );
};

export default ProfileCertificate;
